import {
  AuthContext,
  AuthContextValue,
} from '@contexts/auth-provider/AuthProvider.types';
import { useContext } from 'react';

/**
 * Hook to access authentication context
 *
 * @returns AuthContextValue with authData, isAuthenticated, isLoading, login, logout
 * @throws Error if used outside AuthProvider
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
}
